import { useEffect } from "react";
import { useRouteError, useNavigate, isRouteErrorResponse } from "react-router";
import { AlertCircle } from "lucide-react";
import { Button } from "@/components/ui/button";

// Portal-scoped errorElement. Mirrors /app/portal/error.tsx — a calm card
// inside the existing PortalLayout chrome rather than the global error
// screen, so a query failure on /portal/dashboard doesn't blow away the
// nav. The router catches both thrown Responses (404, 403) and runtime
// exceptions from any portal page or query hook.
export function PortalErrorElement() {
  const error = useRouteError();
  const navigate = useNavigate();

  useEffect(() => {
    console.error("[portal.error]", error);
  }, [error]);

  const status = isRouteErrorResponse(error) ? error.status : 500;
  const message =
    status === 404
      ? "We couldn't find that page."
      : "Reload the page or come back in a moment. Drop us a line if it keeps happening.";

  return (
    <div className="rounded-xl border bg-card p-8 text-center">
      <div className="mx-auto mb-4 flex h-10 w-10 items-center justify-center rounded-full bg-destructive/10 text-destructive">
        <AlertCircle className="h-4 w-4" />
      </div>
      <h2 className="font-display text-lg font-semibold tracking-tight">
        {status === 404 ? "Page not found" : "Something went wrong"}
      </h2>
      <p className="mt-1 text-sm text-muted-foreground">{message}</p>
      <Button
        onClick={() => navigate(0)}
        variant="outline"
        size="sm"
        className="mt-4"
      >
        Retry
      </Button>
    </div>
  );
}
